/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-09-21T14:03:43+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-09-30T13:44:45+02:00
*/

import React from 'react';
import PropTypes from 'prop-types';
import getDisplayName from './../../../utilities/getDisplayName';

function mapChildren(children, childProps = {}) {
  return React.Children.map(children, (child) => (
    React.cloneElement(child, childProps)
  ));
}


/**
 * HOC to wrapp a InputGroupRadios which receives radio-buttons
 * as children. Maps the error and disable state to the children
 * if passed. This way all radios will be disabled when disabled
 * is set to the input group
**/
function inputGroupRadioProps(InputGroupRadioClass) {
  function MInputGroupRadio({
    error,
    disabled,
    children,
    groupName,
    ...other
  }) {
    // create childProps so we only pass value if we have a value!
    const childProps = {};
    if (groupName !== undefined) childProps.groupName = groupName;
    if (disabled !== undefined) childProps.disabled = disabled;
    if (error !== undefined) childProps.error = error;
    const mapedChildren = mapChildren(children, childProps);

    return (
      <InputGroupRadioClass
        {...other}
        groupName={groupName}
        disabled={disabled}
        error={error}
        children={mapedChildren}
      />
    );
  }
  MInputGroupRadio.propTypes = {
    /**
         * pass a group-name to group all inputs as one
         */
    groupName: PropTypes.string.isRequired,
    /**
         * show error state for all radiobuttons
         */
    error: PropTypes.bool,
    /**
         * disable whole selection
         */
    disabled: PropTypes.bool,
    /**
         * pass elements of AInputRadioText
         */
    children: PropTypes.any,
  };
  MInputGroupRadio.defaultProps = {};

  MInputGroupRadio.displayName = `MInputGroupRadio(${getDisplayName(InputGroupRadioClass)})`;

  return MInputGroupRadio;
}

export default inputGroupRadioProps;

